// Shared whitemark (marque blanche) helpers, used by both the app theme
// provider (src/layout/Whitemark.jsx) and the extension one
// (src/popup/tools/WhitemarkExt.jsx) so the guard logic stays in sync.

// Build a CSS color from a stored whitemark value. Guards against the literal
// "undefined" string historically persisted by the whitemark saves
// (JSMLSV3-670) — it would otherwise produce an invalid "#undefined".
export const wmColor = (value, fallback) =>
	value && value !== "undefined" ? `#${value}` : fallback

// First usable value among several candidates (skips falsy and "undefined").
export const firstValidColor = (...values) =>
	values.find((value) => value && value !== "undefined")

// Open the whitemark editor popup and refresh its external data behind the
// loader. isExternalLoaded:false shows the popup loader until the fetch saga
// flips it back to true (on every outcome, including errors). It carries
// skipLocalStorageSync so this control flag never serializes in-flight popup
// previews into localStorage (JSMLSV3-670). Shared by the 3 entry points
// (params card, options navbar, administrator card) to keep them consistent.
export const openWhitemarkEditor = (dispatch) => {
	dispatch({ type: "accountOptions/toggleWhiteMode" })
	dispatch({ type: "action/openAction", payload: "changeWM" })
	dispatch({
		type: "auth/updateWm",
		payload: { isExternalLoaded: false, skipLocalStorageSync: true },
	})
	dispatch({ type: "G_GET_EXTERNAL_WHITEMARK_SAGA" })
}
